// extracted by mini-css-extract-plugin
export default {"name":"UserInfo_name__iuxYp","username":"UserInfo_username__XjD0a","check-icon":"UserInfo_check-icon__S2SDG"};